import {
    CREATE_DASHBOARD_START,
    CREATE_DASHBOARD_SUCCESS,
    CREATE_DASHBOARD_FAIL,
    GET_ALL_DASHBOARDS_START,
    GET_ALL_DASHBOARDS_SUCCESS,
    GET_ALL_DASHBOARDS_FAIL,
    GET_DASHBOARD_BY_ID_START,
    GET_DASHBOARD_BY_ID_SUCCESS,
    GET_DASHBOARD_BY_ID_FAIL,
    GET_DASHBOARD_BY_NAME_START,
    GET_DASHBOARD_BY_NAME_SUCCESS,
    GET_DASHBOARD_BY_NAME_FAIL,
    GET_DASHBOARD_CONFIG_SUCCESS,
    DASHBOARD_CONFIG_FETCH_END,
    DASHBOARD_CONFIG_FETCH_START,
    DELETE_DASHBOARD_START,
    DELETE_DASHBOARD_SUCCESS,
    DELETE_DASHBOARD_FAIL,
    CLEAR_CURRENT_DASHBOARD,
    CLEAR_ALL_DASHBOARDS,
    CLEAR_DASHBOARD_CACHE,
    GET_SQL_QUERIES_START,
    GET_SQL_QUERIES_SUCCESS,
    GET_SQL_QUERIES_FAIL,
    GET_SQL_QUERY_COLUMNS_START,
    GET_SQL_QUERY_COLUMNS_SUCCESS,
    GET_SQL_QUERY_COLUMNS_FAIL,
    RUN_SQL_WORKBENCH_START,
    RUN_SQL_WORKBENCH_SUCCESS,
    RUN_SQL_WORKBENCH_FAIL
} from '../../actions/DashboardConfig/ActionTypes';

const initialState = {
    // Dashboard management
    dashboards: [],
    currentDashboard: null,
    loading: false,
    error: null,
    success: false,
    dashboardConfig: [],
    // SQL queries
    sqlQueries: [],
    loadingSqlQueries: false,
    sqlQueriesError: null,

    // SQL query columns
    sqlQueryColumns: {},
    loadingSqlQueryColumns: {},
    sqlQueryColumnsError: {},

    // SQL workbench results
    sqlWorkbenchResults: {},
    loadingSqlWorkbench: {},
    sqlWorkbenchError: {}
};

const dashboardConfigReducer = (state = initialState, action) => {
    switch (action.type) {
        // Create Dashboard
        case CREATE_DASHBOARD_START:
            return {
                ...state,
                loading: true,
                error: null,
                success: false
            };

        case CREATE_DASHBOARD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                error: null,
                dashboards: [...state.dashboards, action.payload]
            };

        case CREATE_DASHBOARD_FAIL:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload
            };
        case DASHBOARD_CONFIG_FETCH_START:
            return {
                ...state,
                loading: true,
            };

        case DASHBOARD_CONFIG_FETCH_END:
            return {
                ...state,
                loading: false,
            };
        case GET_DASHBOARD_CONFIG_SUCCESS:
            return {
                ...state,
                loading: false,
                dashboardConfig: action.payload,
                error: null,
            };
        case GET_ALL_DASHBOARDS_START:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_ALL_DASHBOARDS_SUCCESS:
            return {
                ...state,
                loading: false,
                dashboards: action.payload, //transformedDashboards,
                error: null
            };

        case GET_ALL_DASHBOARDS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                dashboards: []
            };

        // Get Dashboard By ID
        case GET_DASHBOARD_BY_ID_START:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_DASHBOARD_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                currentDashboard: action.payload,
                error: null
            };

        case GET_DASHBOARD_BY_ID_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                currentDashboard: null
            };

        // Get Dashboard By Name
        case GET_DASHBOARD_BY_NAME_START:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_DASHBOARD_BY_NAME_SUCCESS:
            return {
                ...state,
                loading: false,
                currentDashboard: action.payload,
                error: null
            };

        case GET_DASHBOARD_BY_NAME_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                currentDashboard: null
            };

        // Delete Dashboard
        case DELETE_DASHBOARD_START:
            return {
                ...state,
                loading: true,
                error: null
            };

        case DELETE_DASHBOARD_SUCCESS:
            return {
                ...state,
                loading: false,
                dashboards: state.dashboards.filter(dashboard =>
                    dashboard.id !== action.payload.deletedId
                ),
                error: null
            };

        case DELETE_DASHBOARD_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        // Clear Current Dashboard
        case CLEAR_CURRENT_DASHBOARD:
            return {
                ...state,
                currentDashboard: null,
                error: null
            };

        // Clear All Dashboards
        case CLEAR_ALL_DASHBOARDS:
            return {
                ...state,
                dashboards: [],
                currentDashboard: null,
                loading: false,
                error: null,
                success: false
            };

        // Clear Dashboard Cache
        case CLEAR_DASHBOARD_CACHE:
            return {
                ...state,
                dashboards: [],
                currentDashboard: null,
                loading: false,
                error: null,
                success: false,
                // Also clear SQL related data
                sqlQueries: [],
                loadingSqlQueries: false,
                sqlQueriesError: null,
                sqlQueryColumns: {},
                loadingSqlQueryColumns: {},
                sqlQueryColumnsError: {},
                sqlWorkbenchResults: {},
                loadingSqlWorkbench: {},
                sqlWorkbenchError: {}
            };

        // SQL Queries
        case GET_SQL_QUERIES_START:
            return {
                ...state,
                loadingSqlQueries: true,
                sqlQueriesError: null
            };

        case GET_SQL_QUERIES_SUCCESS:
            return {
                ...state,
                loadingSqlQueries: false,
                sqlQueries: action.payload,
                sqlQueriesError: null
            };

        case GET_SQL_QUERIES_FAIL:
            return {
                ...state,
                loadingSqlQueries: false,
                sqlQueriesError: action.payload
            };

        // SQL Query Columns
        case GET_SQL_QUERY_COLUMNS_START:
            return {
                ...state,
                loadingSqlQueryColumns: {
                    ...state.loadingSqlQueryColumns,
                    [action.queryId]: true
                },
                sqlQueryColumnsError: {
                    ...state.sqlQueryColumnsError,
                    [action.queryId]: null
                }
            };

        case GET_SQL_QUERY_COLUMNS_SUCCESS:
            return {
                ...state,
                loadingSqlQueryColumns: {
                    ...state.loadingSqlQueryColumns,
                    [action.queryId]: false
                },
                sqlQueryColumns: {
                    ...state.sqlQueryColumns,
                    [action.queryId]: action.payload
                },
                sqlQueryColumnsError: {
                    ...state.sqlQueryColumnsError,
                    [action.queryId]: null
                }
            };

        case GET_SQL_QUERY_COLUMNS_FAIL:
            return {
                ...state,
                loadingSqlQueryColumns: {
                    ...state.loadingSqlQueryColumns,
                    [action.queryId]: false
                },
                sqlQueryColumnsError: {
                    ...state.sqlQueryColumnsError,
                    [action.queryId]: action.payload
                }
            };

        // SQL Workbench
        case RUN_SQL_WORKBENCH_START:
            return {
                ...state,
                loadingSqlWorkbench: {
                    ...state.loadingSqlWorkbench,
                    [action.queryId]: true
                },
                sqlWorkbenchError: {
                    ...state.sqlWorkbenchError,
                    [action.queryId]: null
                }
            };

        case RUN_SQL_WORKBENCH_SUCCESS:
            return {
                ...state,
                loadingSqlWorkbench: {
                    ...state.loadingSqlWorkbench,
                    [action.queryId]: false
                },
                sqlWorkbenchResults: {
                    ...state.sqlWorkbenchResults,
                    [action.queryId]: action.payload
                },
                sqlWorkbenchError: {
                    ...state.sqlWorkbenchError,
                    [action.queryId]: null
                }
            };

        case RUN_SQL_WORKBENCH_FAIL:
            return {
                ...state,
                loadingSqlWorkbench: {
                    ...state.loadingSqlWorkbench,
                    [action.queryId]: false
                },
                sqlWorkbenchError: {
                    ...state.sqlWorkbenchError,
                    [action.queryId]: action.payload
                }
            };

        default:
            return state;
    }
};

export default dashboardConfigReducer;